import type { ILinkData } from './dotcms-link';
import { LinkGqlHelper } from './dotcms-link';
import type { IGqlHelper } from './gql-helper';
import type { IModelBasedOnEnrollmentStatus } from './model-based-on-enrollment-status-helper';
import { buildBasedOnEnrollmentStatusGqlHelper } from './model-based-on-enrollment-status-helper';

export type ILinkBasedOnEnrollmentStatusData =
  IModelBasedOnEnrollmentStatus<ILinkData>;

export const LinkBasedOnEnrollmentStatusGqlHelper: IGqlHelper<ILinkBasedOnEnrollmentStatusData> =
  buildBasedOnEnrollmentStatusGqlHelper(
    'LinkBasedOnEnrollmentStatus',
    LinkGqlHelper,
  );
